<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-row>
    <v-col cols="12" xs="12" class="pa-0">
      <TableDevices ref="table" show-title="true"></TableDevices>
    </v-col>

    <v-col cols="12" class="text-right">
      <v-btn @click="reload()" color="primary">Aktualisieren</v-btn>
    </v-col>
  </v-row>
</template>

<script>
// import Vue from 'vue'
// import DialogLinkCompany from './dialogs/DialogLinkCompany'
import TableDevices from "../tables/TableDevices";

export default {
  name: 'Geraete',
  components: {TableDevices},
  data() {
    return {}
  },
  methods: {
    reload: function () {
      this.$refs.table.reload()
    }
  },
  mounted() {
  }
}
</script>

<style scoped>

</style>
